import { getPageContentByDeliveryKey } from '@api/getPageContent';
// Breakdown Amplience Data into array to pass into getComponent function used for page level slots

const loadAsyncData = async (schema, props, geo, componentDirectory, pageNumber) => {
  if (!schema || !geo || !componentDirectory) return;

  if (props.components) {
    // Ensure any async data for Split Background component is loaded
    props.body = props.components;
  }

  // Load async data for any children
  if (props?.body?.length) {
    await Promise.all(
      props.body.map((x) =>
        loadAsyncData(x?._meta?.schema, x, geo, componentDirectory, pageNumber),
      ),
    );
  }

  // find the component in the directory, call its fetchAsync method,
  // and pass the results to the component in a _data prop
  const fetchAsyncImport = componentDirectory[schema];
  if (fetchAsyncImport) {
    const { default: fetchAsync } = await fetchAsyncImport();
    props._data = (await fetchAsync({ ...props, geo, pageNumber })) ?? null;
  }
};

export const loadAsyncDataWithContentRows = async (
  contentType,
  geo,
  componentDirectory,
  pageNumber,
) => {
  if (!contentType || !geo || !componentDirectory) return;

  await loadAsyncData(contentType._meta.schema, contentType, geo, componentDirectory, pageNumber);

  if (!contentType.contentRows?.components?.length) return;

  // For every component in contentRows, load any async data
  await Promise.all(
    contentType.contentRows.components.map((x) =>
      loadAsyncData(x?._meta?.schema, x, geo, componentDirectory, pageNumber),
    ),
  );
};

export const getAndBreakdownDetailPage = async (
  contentType,
  geo,
  componentDirectory,
  pageNumber,
) => {
  const response = await getPageContentByDeliveryKey(geo.generalPage);
  if (response) {
    const components = await breakdownResponse(response);
    return (
      await Promise.all(
        components.map(async (component) => {
          if (component.schema === 'https://traegergrills.com/data/nestedSlot/generalBody.json') {
            await loadAsyncDataWithContentRows(contentType, geo, componentDirectory, pageNumber);
            if (!component) {
              return null;
            }
            return {
              ...component,
              props: {
                ...component.props,
                body: [
                  {
                    schema: contentType._meta.schema ?? null,
                    id: contentType._meta.deliveryId ?? null,
                    props: contentType ?? null,
                  },
                ],
              },
            };
          }
          return component;
        }),
      )
    ).filter(Boolean);
  }
};

const breakdownResponse = async ({ body } = {}, geo, componentDirectory, pageNumber) => {
  if (Array.isArray(body?.body)) {
    return (
      await Promise.all(
        body.body.map(async (child) => {
          if (child._meta) {
            await loadAsyncData(child._meta.schema, child, geo, componentDirectory, pageNumber);
            return {
              schema: child._meta.schema ?? null,
              id: child._meta.deliveryId ?? null,
              props: child ?? null,
            };
          } else {
            console.warn(
              `Child Content: ${child} does not contain _meta property, can not be mapped`,
            );
          }
        }),
      )
    ).filter(Boolean);
  } else if (body?._meta) {
    return getAndBreakdownDetailPage(body, geo, componentDirectory, pageNumber);
  }
};

// Breakdown Data inside of a slot body component, used for nested slots
export const breakdownChildResponse = (res) => {
  if (Array.isArray(res)) {
    return res
      .filter((child) => {
        if (!child?._meta) {
          console.warn(`Child Content ${child} does not contain _meta property, can not be mapped`);
          return false;
        }
        return true;
      })
      .map((child) => ({
        schema: child._meta.schema,
        id: child._meta.deliveryId,
        props: child,
      }));
  } else {
    console.warn(`Content: ${res} is not formatted correctly.`);
  }
};

export default breakdownResponse;
